import { rankingItems } from '@/mocks/homeData';

export default function SectionRanking() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-accent-500 text-xs"></i>;
    if (trend === 'down') return <i className="ri-arrow-down-line text-foreground-400 text-xs"></i>;
    return <i className="ri-subtract-line text-foreground-400 text-xs"></i>;
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">热度排行</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">热播榜单</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">根据播放热度与观众评分综合排名的超清影视播放榜单</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-50 transition-colors cursor-pointer border-b border-background-200 last:border-b-0"
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-300 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="w-12 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" loading="lazy" />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-400 mt-0.5">{item.meta}</p>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                <span className="text-sm font-bold text-accent-600">{item.score}</span>
                {trendIcon(item.trend)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}